<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <Header/>
    </div>
    <b-container fluid class="pb-4">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Alta de Planes y Convenios*</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div></div>
        </b-col>
      </b-row>
      <b-row>
        <b-tabs @input="cambioTab($event)" class="w-100" content-class="mt-3" justified>
          <b-tab v-if="$localStorageService.can('Plan_con_01')" title="Plan/convenio" active>
            <b-col>
              <b-row>
                <!--nombre--->
                <b-col>
                  <b-form-group id="input-nombre" label="Nombre:" label-for="nombre">
                    <b-form-input
                        id="nombre"
                        v-model="$v.plan.nombre.$model"
                        :state="validateState('nombre')"
                        v-on:keypress="isLetter($event)"
                        type="text"
                        onpaste="return false"
                        required
                    ></b-form-input>
                  </b-form-group>
                </b-col>

                <!--area--selects--->


                <!--nombre--->
                <b-col>
                  <b-form-group label="Cuenta :" label-for="cuenta">
                      <v-select
                          id="cuenta"
                          label="nombreCuenta"
                          v-model="$v.plan.cuenta.$model"
                          :state="validateState('cuenta')"
                          :class="selectClass('cuenta')"
                          :options="cuentas"
                          required
                      ></v-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Canal de Salida:" label-for="idSistema">
                    <v-select style="width: 100%" :options="listaCanalOrigen"
                              v-model="$v.plan.idCanalSalida.$model" :reduce="(variable) => variable.idCanalOrigen" label="descripcion"
                              placeholder="Selecciona el canal de salida (*)" id="idSistema">
                      <span slot="no-options">No hay canales disponibles</span>
                    </v-select>
                  </b-form-group>
                </b-col>
                <!--area--selects--->
              </b-row>
              <b-row>

                <!--area- select--->
                <b-col>
                  <b-form-group id="input-areas" label="Area:" label-for="areas">
                    <v-select
                        id="areas"
                        label="nombreArea"
                        v-model="$v.plan.area.$model"
                        :state="validateState('area')"
                        :options="areas"
                        @input="obetenerCoberturas()"
                        :class="selectClass('area')">
                        required
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="input-cobertura" label="Cobertura:" label-for="cobertura">
                    <v-select
                        id="cobertura"
                        label="descripcion"
                        v-model="$v.plan.cobertura.$model"
                        :state="validateState('cobertura')"
                        :class="selectClass('cobertura')"
                        :options="coberturas"
                        required
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="input-tipo" label="Tipo:" label-for="tipo">
                    <v-select
                        id="tipo"
                        label="nombreTipoPlan"
                        v-model="$v.plan.tipo.$model"
                        :state="validateState('tipo')"
                        :class="selectClass('tipo')"
                        :options="planes"
                        required
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col v-if="$localStorageService.can('BO_13_plan_precio')">
                  <b-form-group id="input-precio" label="Precio:" label-for="precio">
                    <b-form-input
                        id="precio"
                        v-model="$v.plan.precio.$model"
                        :state="validateState('precio')"
                        type="number"
                        required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="input-tipo" label="Tipo Comision Plan:" label-for="tipo">
                    <v-select
                        id="tipo"
                        label="tipoComisionPlan"
                        v-model="$v.plan.idTipoComisionPlan.$model"
                        :reduce="(variable) => variable.idTipoComisionPlan"
                        :options="listaTipoComisiones"
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="input-comision" label="Comisión:" label-for="comision">
                    <b-form-input
                        id="comision"
                        v-model="$v.plan.comision.$model"
                        :state="validateState('comision')"
                        type="number"
                        required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <!------Descripcion-------->
                <b-col>
                  <b-form-group id="input-descripcion" label="Descripción:"
                                label-for="descripcion">
                    <b-form-textarea
                        id="descripcion"
                        v-model="$v.plan.descripcion.$model"
                        :state="validateState('descripcion')"
                        type="text"
                        required
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
                <!------Requisitos-------->
                <b-col>
                  <b-form-group id="input-requisitos" label="Requisitos:" label-for="requisitos">
                    <b-form-textarea
                        id="requisitos"
                        v-model="$v.plan.requisitos.$model"
                        :state="validateState('requisitos')"
                        type="text"
                        required
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
              <fieldset>
                <legend>Vigencia de la Poliza del Paciente</legend>
                <b-row>

                  <b-col>
                    <b-form-group id="input-inicio-contrato" label="Fecha inicio:" label-for="inicioC">
                      <b-form-datepicker  id="inicioC"
                                          no-flip
                                          v-model="$v.plan.fechaInicioContrato.$model"
                                          :state="validateState('fechaInicioContrato')"
                                          class="mb-2"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="input-fin-contrato" label="Fecha fin :" label-for="finC">
                      <b-form-datepicker id="finC" :min="plan.fechaInicioContrato"
                                         no-flip
                                         v-model="$v.plan.fechaFinContrato.$model"
                                         :state="validateState('fechaFinContrato')"
                                         class="mb-2"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                </b-row>
              </fieldset>
              <fieldset>
                <legend>Vigencia del plan</legend>
                <b-row>

                  <b-col>
                    <b-form-group id="input-inicio" label="Fecha inicio:" label-for="inicio">
                      <b-form-datepicker :disabled="plan.fechaInicioContrato === null" :min="plan.fechaInicioContrato" :max="plan.fechaFinContrato" id="inicio"
                                         no-flip
                                         v-model="$v.plan.fechaInicio.$model"
                                         :state="validateState('fechaInicio')"
                                         class="mb-2"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="input-fin" label="Fecha fin:" label-for="fin">
                      <b-form-datepicker :disabled="plan.fechaFinContrato === null"  id="fin" :min="plan.fechaInicio" :max="plan.fechaFinContrato"
                                         no-flip
                                         v-model="$v.plan.fechaFin.$model"
                                         :state="validateState('fechaFin')"
                                         class="mb-2"></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                </b-row>
              </fieldset>
              <b-row>
                <b-col>
                  <b-form-group id="input-areas" label="Vigencia a aplicar  (paciente):" label-for="vigencia">
                    <v-select
                        id="vigencia"
                        label="descripcion"
                        v-model="$v.plan.vigencia.$model"
                        :state="validateState('vigencia')"
                        :class="selectClass('vigencia')"
                        :options="vigencias"
                        required
                    ></v-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Responsable:" label-for="resonsable">
                    <v-select
                        id="resonsable"
                        label="empleado"
                        :options="responsables"
                        v-model="$v.plan.responsable.$model"
                        :state="validateState('responsable')"
                        :class="selectClass('responsable')"
                        required
                    ></v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="text-left">
                <b-col>
                  <b-form-group label="Tipo de descuento :">
                    <b-form-radio v-model="$v.plan.tipoDescuento.$model"
                                  :state="validateState('tipoDescuento')" name="descuento" :value="1">
                      Porcentaje
                    </b-form-radio>
                    <b-form-radio v-model="plan.tipoDescuento" name="descuento" :value="2">
                      Precio Especial
                    </b-form-radio>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group label="Tipo de Categoria :">
                    <b-form-radio v-model="$v.plan.tipoCategoria.$model"
                                  :state="validateState('tipoDescuento')" name="tipoCategoria" :value="1">
                      Plan
                    </b-form-radio>
                    <b-form-radio v-model="plan.tipoCategoria" name="tipoCategoria" :value="2">
                      Beneficio
                    </b-form-radio>
                  </b-form-group>
                </b-col>
              </b-row>
              <hr>

              <b-row class=" pb-3" >
                <b-col style="margin-top: 3%">
                  <b-button  v-if="$localStorageService.can('Plan_con_01_guar')" variant="outline-primary" :disabled="loader" @click="guardar()">
                    <span v-if="!loader">Guardar</span>
                    <span v-if="loader">
                        <b-spinner small></b-spinner>
                    Guardando...
                    </span>
                  </b-button>
                </b-col>
              </b-row>
              <div style="height: 70px"></div>
            </b-col>
          </b-tab>
          <b-tab v-if="$localStorageService.can('Razon_social_Plan') && idPlan !== null" title="Razón Social">
            <div v-if="indexTab === 1">
              <razon-social :id-plan="idPlan" @set-Done="setDone" :plan="plan.nombre"></razon-social>
            </div>
          </b-tab>
          <b-tab v-if="$localStorageService.can('Plan_con_01_carac') && idPlan !== null" title="Caracteristicas">
            <div v-if="indexTab === 2">
              <app-caracteristicas :id-plan="idPlan" @set-Done="setDone" :plan="plan.nombre"></app-caracteristicas>
            </div>
          </b-tab>
          <b-tab v-if="$localStorageService.can('Plan_con_01_portal') && idPlan !== null" title="Portal linea">
            <div v-if="indexTab === 3">
              <portalLinea :id-plan="+idPlan" @set-Done="setDone"></portalLinea>
            </div>
          </b-tab>
          <b-tab v-if="$localStorageService.can('Plan_con_01_tx') && idPlan !== null" title="Tratamientos">
            <div v-if="indexTab === 4">
              <TratamientosPlan :id-plan="idPlan" @set-Done="setDone"></TratamientosPlan>
            </div>
          </b-tab>
          <b-tab v-if="$localStorageService.can('Plan_con_01_vistaP') && idPlan !== null" title="Vista previa">
            <div v-if="indexTab === 5">
              <md-content class="md-primary">
                <h2>¡Ha terminado el proceso exitosamente!</h2>
                Sin embargo, para que este plan/convenio pueda ser utilizado primero debe asignarlo
                a alguna compañía, haga click en asignara plan a compania para proceder.
                A continuación se muestra a detalle la información ingresada.
              </md-content>

              <div v-if="actualizar">
                <detalle-plan :id="idPlan"></detalle-plan>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-row>
    </b-container>
  </div>
</template>

<script>
//components
import Header from '../components/Header.vue'
import detallePlan from "./ventas/plan/detallePlan";
import portalLinea from "./ventas/plan/PortalLinea.vue"
import TratamientosPlan from "./ventas/plan/TratamientosPlan";
import {numeric, required} from "vuelidate/lib/validators";
import RazonSocial from "@/views/ventas/plan/RazonSocial";

export default {
  name: "app",
  el: '#appVue',
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    idPlan: null,
    indexTab: 0,
    plan: {
      id: null,
      nombre: null,
      cuenta: null,
      area: null,
      cobertura: null,
      tipo: null,
      precio: null,
      descripcion: null,
      requisitos: null,
      fechaInicio: null,
      fechaFin: null,
      fechaInicioContrato: null,
      fechaFinContrato: null,
      vigencia: null,
      responsable: null,
      tipoDescuento: null,
      tipoRequerido: null,
      idTipoComisionPlan: null,
      comision: null
    },
    areas: [],
    coberturas: [],
    cuentas: [],
    planes: [],
    vigencias: [],
    responsables: [],
    editarconvenionuevo: false,

    active: 'first',
    first: false,
    second: false,
    actualizar: true,
    third: true,
    loader: false,
    secondStepError: null,
    listaCanalOrigen: [],
    blnPlanTienePortalLinea: false,
    listaTipoComisiones: [],
    comision: false

  }),
  validations: {
    plan: {
      nombre: {required},
      cuenta: {required},
      area: {required},
      cobertura: {required},
      tipo: {required},
      precio: {required, numeric},
      descripcion: {required},
      requisitos: {required},
      fechaInicio: {required},
      fechaFin: {required},
      fechaInicioContrato: {required},
      fechaFinContrato: {required},
      vigencia: {required},
      responsable: {required},
      tipoDescuento: {required},
      tipoCategoria: {required},
      idCanalSalida: {required, numeric},
      idTipoComisionPlan:{required},
      comision:{required}
    }
  },

  filters: {
    jsonStringify(val) {
      return JSON.stringify(val)
    }
  },
  components: {
    RazonSocial,
    Header,
    detallePlan,
    TratamientosPlan,
    portalLinea
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    if (this.$route.params.id) {
      this.idPlan = this.$route.params.id
      this.buscarInformacionPlan(this.$route.params.id)
      this.traerDatosPortalLinea(this.$route.params.id);
    }
    this.obetenerAreas();
    this.obetenerCoberturas();
    this.obetenerVigencias();
    this.obtenerCuentas();
    this.obetenerTipoPlanes();
    this.obetenerTipoComisionesPlan();
    this.obtenerResponsables();
    this.obtenerCanalesOrigen();
  },
  methods: {
    obetenerAreas() {
      this.$http.get(this.$api + 'catalogos/listaAreasCobertura').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.areas.push(it);
              })
            }
          }
      )
    },
    obetenerCoberturas() {
      if (this.plan.area != null) {
        this.$http.post(this.$api + 'catalogos/listaCoberturas', this.plan.area.idArea).then(respuesta => {
              if (respuesta.data.data) {
                this.coberturas = respuesta.data.data;
              }
            }
        )
      } else {
        this.coberturas = []
      }
    },
    obetenerVigencias() {
        this.$http.get(this.$api + 'catalogos/vigencias').then(respuesta => {
              if (respuesta.data.data) {
                this.vigencias = respuesta.data.data;
              }
            }
        )
    },
    obetenerTipoPlanes() {
      this.$http.get(this.$api + 'catalogos/listaTiposPlan').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.planes.push(it);
              })
            }
          }
      )
    },
    obetenerTipoComisionesPlan() {
      this.$http.get(this.$api + 'catalogos/obtenerTipoComisionesPlan').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaTipoComisiones.push(it);
              })
            }
          }
      )
    },
    obtenerResponsables() {
      this.$http.get(this.$api + 'planConvenio/obtener/resposables').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.responsables.push(it);
              })
            }
          }
      )
    },
    obtenerCuentas() {
      this.$http.get(this.$api + 'planConvenio/obtener/cuentas').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.cuentas.push(it);
              })
            }
          }
      )
    },
    obtenerCanalesOrigen() {
      this.loader = true;
      this.$http.get(this.$api + 'catalogos/obtenerCanalesOrigen').then(respuesta => {
            if (respuesta.data.data) {
              this.listaCanalOrigen = respuesta.data.data;
              this.listaCanalOrigen = this.listaCanalOrigen.filter(e => e.idCanalOrigen === 24 || e.idCanalOrigen === 28)
            }

          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    buscarInformacionPlan(id) {
      const parametros = {idPlan: id}
      this.$http.post(this.$api + 'planConvenio/obtener/plan', parametros).then(respuesta => {
            if (respuesta.data.data) {
              this.plan = respuesta.data.data;
            }
          }
      )
    },
    traerDatosPortalLinea(idPlan) {
      this.blnPlanTienePortalLinea = false;
      const parametros = {idPlan: idPlan}
      this.$http.post(this.$api + 'planConvenio/traerPortal/linea', parametros)
          .then(portalLinea => {
            if (portalLinea.data.data.idPlanPortal != null) {
              this.blnPlanTienePortalLinea = true;
            }
          })
          .catch((err) => {
            this.errorTraerDatos(err);
          }).finally(() => {
      })
    },
    guardar(){
      if(this.blnPlanTienePortalLinea && (this.plan.idCanalSalida !== 24)){
        this.$swal.fire({
              icon: "info",
              title: "Aviso",
              html:'<p><strong>¿Estás de acuerdo con la configuración actual del plan?</strong></p>' +
                  '<br>' +
                  '<p>El canal de salida seleccionado desactivará las configuraciones del Portal Comercial.</p>',
              showCancelButton: true,
              cancelButtonText:"Cancelar",
              confirmButtonText:"Confirmar"
            }).then((result) => {
              if (result.isConfirmed) {
              this.$v.plan.$touch();
              if (this.$v.plan.$anyError) {
                return;
              }
              if (!this.$v.plan.$invalid) {
                this.loader = true;
                const envio = JSON.parse(JSON.stringify(this.plan))

                // let ini = new Date(this.plan.fechaInicio);
                // ini.setHours(0, 0, 0, 0)
                // let fin = new Date(this.plan.fechaFin);
                // fin.setHours(23, 59, 59, 999)
                // envio.fechaInicio = this.$moment(ini).utc()
                // envio.fechaFin = this.$moment(fin).utc()
                //
                //
                // ini = new Date(this.plan.fechaInicioContrato);
                // ini.setHours(0, 0, 0, 0)
                //
                // fin = new Date(this.plan.fechaFinContrato);
                // fin.setHours(23, 59, 59, 999)
                //
                // envio.fechaInicioContrato = this.$moment(ini).utc()
                // envio.fechaFinContrato = this.$moment(fin).utc()

                this.$http.post(this.$api + 'planConvenio/plan/guardar', envio).then(respuesta => {
                      if (respuesta.data.data) {
                        this.plan = respuesta.data.data;
                        this.idPlan = respuesta.data.data.idPlan;
                        this.secondStepError = null

                        this.$swal({
                          icon: "success",
                          text: "Plan guardado correctamente",
                          confirmButtonText: "OK",
                          confirmButtonColor: "#0e6ba9",
                          onClose: () => {
                          },
                        });

                      }
                    }
                ).finally(() => {
                  this.loader = false;
                })
              }
            }else{
              return false;
            }
          });
      }else{
        this.$v.plan.$touch();
        if (this.$v.plan.$anyError) {
          return;
        }
        if (!this.$v.plan.$invalid) {
          this.loader = true;
          const envio = JSON.parse(JSON.stringify(this.plan))

          // let ini = new Date(this.plan.fechaInicio);
          // ini.setHours(0, 0, 0, 0)
          // let fin = new Date(this.plan.fechaFin);
          // fin.setHours(23, 59, 59, 999)
          // envio.fechaInicio = this.$moment(ini).utc()
          // envio.fechaFin = this.$moment(fin).utc()
          //
          //
          // ini = new Date(this.plan.fechaInicioContrato);
          // ini.setHours(0, 0, 0, 0)
          //
          // fin = new Date(this.plan.fechaFinContrato);
          // fin.setHours(23, 59, 59, 999)
          //
          // envio.fechaInicioContrato = this.$moment(ini).utc()
          // envio.fechaFinContrato = this.$moment(fin).utc()

          this.$http.post(this.$api + 'planConvenio/plan/guardar', envio).then(respuesta => {
                if (respuesta.data.data) {
                  this.plan = respuesta.data.data;
                  this.idPlan = respuesta.data.data.idPlan;
                  this.secondStepError = null

                  this.$swal({
                    icon: "success",
                    text: "Plan guardado correctamente",
                    confirmButtonText: "OK",
                    confirmButtonColor: "#0e6ba9",
                    onClose: () => {
                    },
                  });

                }
              }
          ).catch((e) => {
            this.$swal.fire({
              icon: "error",
              title: "Ocurrio un error",
              text: e.response.data.message,
            });
          }).finally(() => {
            this.loader = false;
          })
        }
      }
    },
    setDone(id, index) {
      this.actualizar = false;
      this.plan.fechaInicio = this.$moment(this.plan.fechaInicio).utc()
      this.plan.fechaFin = this.$moment(this.plan.fechaFin).utc()
      this.$http.post(this.$api + 'planConvenio/plan/guardar', this.plan).then(respuesta => {
            if (respuesta.data.data) {
              this.plan = respuesta.data.data;
              this.idPlan = respuesta.data.data.idPlan;

              this[id] = true

              this.secondStepError = null

              if (index) {
                this.active = index
              }
            }
          }
      ).finally(() => {
        this.actualizar = true;
      })
    },
    setError() {
      this.secondStepError = 'This is an error!'
    },
    cambioTab(item) {
      this.indexTab = item
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.plan[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if ( state ) {
        return 'border rounded-lg border-success'
      } else if ( state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    },
      isLetter(e) {
        let char = String.fromCharCode(e.keyCode); // Get the character
        if (/^[A-Za-z0-9 áéíóúÁÉÍÓÚñÑ]*$/.test(char)) return true;
        // Match with regex
        else e.preventDefault(); // If not match, don't add to input text
      }
  }
};
</script>

<style>

</style>
